import { Language } from 'interface/settings/settings.interface';

export const getBrowserLanguageCode = <T extends string>(
  supportedLanguages: readonly T[],
  fallback: T = (supportedLanguages[0] ?? 'en') as T,
): T => {
  if (typeof navigator === 'undefined') return fallback;

  const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];

  for (const browserLanguage of browserLanguages) {
    const code = browserLanguage.toLowerCase().split('-')[0] as T;
    if (supportedLanguages.includes(code)) return code;
  }

  return fallback;
};

export const getSelectedlanguage = (languages: Language[], selectedLanguageId?: string) => {
  const selectedLang = languages.find((lang) => lang.id === selectedLanguageId);
  const defaultLang = languages.find((lang) => lang.isDefault);
  if (selectedLang) {
    return {
      id: selectedLang.id,
      text: `${selectedLang.name.toUpperCase()}${selectedLang.isDefault ? ' (default)' : ''}`,
    };
  } else if (defaultLang) {
    return { id: defaultLang.id, text: `${defaultLang.name.toUpperCase()} (default)` };
  } else if (languages.length > 0) {
    return { id: languages[0].id, text: `${languages[0].name.toUpperCase()} (default)` };
  } else {
    return { id: 'en', text: 'ENGLISH (default)' };
  }
};
